// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071010/js/" + chunkId + "." + {"44":"f6db3b85","225":"ff3ef3ab","481":"28a49dd0","486":"fa449d57","770":"9c15ce72"}[chunkId] + ".0.8400404942622157.chunk.js";
};